import { apolloClient } from '@/plugins/apollo'
import {
  ADD_RENTAL_ITEM_RESERVATION, UPDATE_RENTAL_ITEM_RESERVATION_INPUT, UPDATE_RENTAL_ITEM_RESERVATIONS
} from '@/api/graphql/bookingDetail/booking-rental-list'
import router from '../../../router'
import { handlError, setCopyErrorTextCommit } from '@/constants/functions'
import gql from 'graphql-tag'
import { isChargeDuplicationConfirmationRequired } from '@/utils/chargeDuplicationConfirmation'

export default {
  async addRentalItemReservation ({ commit, state, rootState }, { allowChargeDuplication = false } = {}) {
    const variables = {
      bookingId: parseInt(router.currentRoute.query.id),
      rentalItems: {
        rentalItemId: parseInt(state.bookingRental.rentalItemId),
        fromDate: state.bookingRental.fromDate,
        toDate: state.bookingRental.toDate,
        quantity: parseInt(state.bookingRental.quantity)
      },
      allowChargeDuplication
    }
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: gql`${ADD_RENTAL_ITEM_RESERVATION}`,
        variables: variables
      }).then(data => {
        resolve(data)
        commit('setCreateBookingRental', true)
        commit('setAlertSuccess', rootState.alert.success.messages.createSuccess, { root: true })
      }).catch(error => {
        if (isChargeDuplicationConfirmationRequired(error)) {
          reject(error)
          return
        }
        setCopyErrorTextCommit(commit, ADD_RENTAL_ITEM_RESERVATION, variables, error.graphQLErrors)
        handlError(commit, error.graphQLErrors)
        reject(error)
      })
    })
  },

  async updateRentalItemReservation ({ commit, state, rootState }, { allowChargeDuplication = false } = {}) {
    const variables = {
      data: {
        rentalItemReservationId: parseInt(state.updateBookingRental.rentalItemReservationId),
        newFromDate: state.updateBookingRental.newFromDate,
        newToDate: state.updateBookingRental.newToDate,
        newQuantity: parseInt(state.updateBookingRental.newQuantity)
      },
      allowChargeDuplication
    }
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: gql`${UPDATE_RENTAL_ITEM_RESERVATION_INPUT}`,
        variables: variables
      }).then(data => {
        commit('setStatusUpdate', true)
        commit('setAlertSuccess', rootState.alert.success.messages.createSuccess, { root: true })
        resolve(data)
      }).catch(error => {
        if (isChargeDuplicationConfirmationRequired(error)) {
          reject(error)
          return
        }
        setCopyErrorTextCommit(commit, UPDATE_RENTAL_ITEM_RESERVATION_INPUT, variables, error.graphQLErrors)
        handlError(commit, error.graphQLErrors)
        reject(error)
      })
    })
  },

  async updateRentalItemReservations ({ commit, rootState }, {
    data,
    allowChargeDuplication = false,
    isDelete = false
  }) {
    const variables = {
      bookingId: parseInt(router.currentRoute.query.id),
      data,
      allowChargeDuplication
    }
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: gql`${UPDATE_RENTAL_ITEM_RESERVATIONS}`,
        variables: variables
      }).then(data => {
        resolve(data)
        commit('setCreateBookingRental')
        const message = isDelete
          ? rootState.alert.success.messages.deleteSuccess
          : rootState.alert.success.messages.updateSuccess
        commit('setAlertSuccess', message, { root: true })
      }).catch(error => {
        if (isChargeDuplicationConfirmationRequired(error)) {
          reject(error)
          return
        }
        setCopyErrorTextCommit(commit, UPDATE_RENTAL_ITEM_RESERVATIONS, variables, error.graphQLErrors)
        handlError(commit, error.graphQLErrors)
        reject(error)
      })
    })
  }
}
